module.exports = __webpack_public_path__ + "static/gallery_12-thumb-5c903213d4095044c4b01bb65f015356.jpg";